<!-- 报名明细 -->
<template>
  <div class="main">
    <back />
    <h2 class="title">活动名称:爬山</h2>
    <div class="s_wrapper">
      <el-input class="s_input" v-model="userName" suffix-icon="el-icon-search" placeholder="搜索用户名称" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="telPhone" suffix-icon="el-icon-search" placeholder="搜索手机号码" clearable
        @change="onSearch"></el-input>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="userName" label="用户名称" min-width="160"></el-table-column>
        <el-table-column show-overflow-tooltip label="性别" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.sex == 1">女</span>
            <span v-if="scope.row.sex == 2">男</span>
          </template>
        </el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="age" label="年龄"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="" label="出生日期"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="" label="手机号码"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="" label="报名时间"></el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      project: "",
      userName: "",
      telPhone: "",
      tableData: [], //表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.userCode = this.$route.query.userCode || ''
    // this.selectUserIntegral()
  },

  methods: {
    // 获取列表
    selectUserIntegral() {
      this.loading = true
      let params = {
        integralType: this.project || null,
        userName: this.userName || null,
        userCode: this.userCode || null,
        page: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$axios
        .get(this.$api.selectUserIntegral, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.desc)
        })
    },
    onSearch() {
      this.clearData()
      this.selectUserIntegral()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectUserIntegral()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectUserIntegral()
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  .title {
    margin-top: 30px;
  }
}
</style>
